import { DateRangeValueType, FilterOptionsByForAuditLog } from "../models";

interface CommonAttrs {
  searchQuery?: string;
  dateRangeFilter?: DateRangeValueType;
}

export class CreateFilterOptionsForAuditLog {
  filterOptions: FilterOptionsByForAuditLog = {};

  constructor(attrs: CommonAttrs) {
    const { dateRangeFilter } = attrs;

    const isReallyRangePicker =
      dateRangeFilter &&
      Array.isArray(dateRangeFilter) &&
      dateRangeFilter?.length > 1;

    if (isReallyRangePicker) {
      this.filterOptions.dateRangeFilter =
        dateRangeFilter as DateRangeValueType;
    }
  }
}
